<template>
    <div :class="['page about',{ off: !pageOn }]">
        <VHeader type="back" @back="pageOn = false;" />
        <div class="page-content copper">
            <div style="position: relative;">
                <img class="page-image" src="/CopperDetail-2.png" />
                <div class="div-btns" style="position: absolute;top:0px;left:0px">
                    <input class="i-name" placeholder="Your Name" v-model="name" style="position: absolute;top:135px;left:35px;width:292px;background-color:rgba(200,0,0,0)" />
                    <input placeholder="Mobile Number" v-model="mobile" style="position: absolute;top:200px;left:35px;width:292px;background-color: rgba(200,0,0,0)" />
                    <input placeholder="Email Address" v-model="email" style="position: absolute;top:269px;left:35px;width:292px;background-color: rgba(200,0,0,0)" />
                    <p @click="join" style="position:absolute;width:345px;height:65px;background-color:rgba(255,0,0,0);top:330px;left:20px"></p>
                </div>
            </div>
        </div>  
    </div>
   
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import { mapActions, mapMutations, mapState } from 'vuex';
import Alert from '@/utils/Alert.js';

export default {
    name: 'copper-detail',
    mixins: [ pageOn ],
    components: {
        VHeader
    },
    computed: {
        copper () { return this.$store.state.copper }
    },
    data () {
        return {
            name: '',
            email: '',
            mobile: '',
            _id: ''
        }
    },
    mounted () {
        var width = parseInt(getComputedStyle(this.$el.querySelector('.page-content')).width);
        this.$el.querySelector('.div-btns').style.transform = 'scale('+( width / 414 )+')';
        if ( this.copper ) {
            this.name = this.copper.name;
            this.email = this.copper.email;
            this.mobile = this.copper.phone;
            this._id = this.copper._id;
        }
        console.log('mounted CopperDetail');
    },
    methods: {
        join () {
            if ( !this.mobile || isNaN(this.mobile) ) return Alert.message('Please provide a valid mobile number');
            this.setValue({
                k: 'copper',
                v: {
                    name: this.name,
                    phone: this.mobile,
                    email: this.email,
                    _id: this._id,
                    amount: 10
                }
            });
            this.pushPage('pay');
        },
        ...mapMutations([
            'popPage',
            'pushPage',
            'setValue'
        ])
    },

    
}

</script>

<style lang="scss">

</style>